module.exports = __webpack_public_path__ + "static/media/munikum-logo.15e87348.png";